import { render, staticRenderFns } from "./ModalCreateContextItem.vue?vue&type=template&id=2d1300bc&scoped=true"
import script from "./ModalCreateContextItem.vue?vue&type=script&lang=js"
export * from "./ModalCreateContextItem.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateContextItem.vue?vue&type=style&index=0&id=2d1300bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1300bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1300bc')) {
      api.createRecord('2d1300bc', component.options)
    } else {
      api.reload('2d1300bc', component.options)
    }
    module.hot.accept("./ModalCreateContextItem.vue?vue&type=template&id=2d1300bc&scoped=true", function () {
      api.rerender('2d1300bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalCreateContextItem.vue"
export default component.exports